import { request, requestSiteMutation } from "./client";
import type { Me, Plugin, Site } from "./types";
import { observeSite, observeSiteList } from "../siteEvents";

export const sitesApi = {
  me: () => request<Me>("/api/sites/me"),
  listSites: async () => {
    const result = await request<{ sites: Site[] }>("/api/sites");
    observeSiteList(result.sites);
    return result;
  },
  getSite: async (id: string) => {
    const site = await request<Site>(`/api/sites/${id}`);
    observeSite(site);
    return site;
  },
  archiveSite: (id: string, archived: boolean) => requestSiteMutation<Site>(`/api/sites/${id}`, { method: "PATCH", body: JSON.stringify({ archived }) }),
  deleteSite: (id: string, confirmSubdomain: string) => requestSiteMutation<{ ok: true }>(`/api/sites/${id}`, { method: "DELETE", body: JSON.stringify({ confirmSubdomain }) }),
  getPlugins: (siteId: string) => request<Plugin>(`/api/sites/${siteId}/plugins`),
  updatePlugin: (siteId: string, integrationId: string, config: Record<string, string>) =>
    request<{
      ok: true;
      integrationConfig: Record<string, Record<string, string>>;
      integrations: string[];
    }>(`/api/sites/${siteId}/plugins`, {
      method: "POST",
      body: JSON.stringify({ integrationId, config }),
    }),
};
